/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Badge_ConfirmInputs */

const en_directory_submit_badge_confirm = /** @type {(inputs: Directory_Submit_Badge_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I have placed the badge and link on this website.`)
};

const zh_directory_submit_badge_confirm = /** @type {(inputs: Directory_Submit_Badge_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我已在这个网站上放置了徽章和链接。`)
};

/**
* | output |
* | --- |
* | "I have placed the badge and link on this website." |
*
* @param {Directory_Submit_Badge_ConfirmInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_badge_confirm = /** @type {((inputs?: Directory_Submit_Badge_ConfirmInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Badge_ConfirmInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_badge_confirm(inputs)
	return zh_directory_submit_badge_confirm(inputs)
});
export { directory_submit_badge_confirm as "directory.submit.badge_confirm" }